import { Employment } from "@/models/employment";
import { Pagination } from "@/models/pagination";
import { IEmployment, EmploymentState } from "@/types/employment";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<EmploymentState, IEmployment> = {
  single: (state, single) => {
    state.single = new Employment(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Employment(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Employment();
    state.pagination = new Pagination();
  },
};

export default mutations;
